require([
	'jquery',
	'base/MbiHelper',
	'jueryUI',
	'root/Assets/Js/Vendor/weekPicker'
], function($, _){

	'use strict';

	var noDataString = "kein aktueller Preis";
	var currentWeek = Number($('.calendar__week-number .js_week').html());

	$('#inputCalendar').on('weekChanged',  function(){
		var $calendar = $(this).closest('.js_calendar'),
			$prevItem = $(this).prev(),
			ywString = $prevItem.html(),
			ywArray = ywString.split('-'),
			year = ywArray[0],
			week = ywArray[1],
			$week = $calendar.find('.js_week');

			$week.html(week);
			$week.attr('data-year', year);
			updateMarktPriceHtml(year, week);
			$.datepicker._hideDatepicker();
	});

	if (_.exists('#inputCalendar')) {

		$.datepicker.setDefaults({
			firstDay: 4
		});

		var lang = $('html').attr('lang');
		if ( lang =='de-DE' ) {
			$.datepicker.regional['de'] = {clearText: 'Löschen', clearStatus: '',
			    closeText: 'Schließen', closeStatus: 'schließen ohne Ändern',
			    prevText: '&#x3c;zurück', prevStatus: '',
			    nextText: '&#x3c;&#x3c;', nextStatus: '',
			    currentText: 'Courant', currentStatus: 'Voir le mois courant',
			    showWeek: true,
			    weekHeader: 'SW',
			    monthNames: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
			    monthNamesShort: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
			    dayNames: ['Sonntag','Montag','Dienstag','Mittwoch','Donnerstag','Freitag','Samstag'],
			    dayNamesShort: ['So','Mo','Di','Mi','Do','Fr','Sa'],
			    dayNamesMin: ['So','Mo','Di','Mi','Do','Fr','Sa'],
			    dateFormat:'d MM, y'
	    	};

	 		$.datepicker.setDefaults($.datepicker.regional['de']);

		}

		convertToWeekPicker($('#inputCalendar'));
		// $('#inputCalendar').datepicker();
		// $( "#inputCalendar" ).datepicker( "option", "firstDay", 4 );

		$(document).on('datePickerHidden', function(){
			var $calendar = $('#inputCalendar').closest('.js_calendar');
			if ($calendar.hasClass('calendar-open')) {
				$calendar.removeClass('calendar-open');
				$('body').removeClass('calendar-active');
			}
		});
		$(document).on('datePickerShown', function(){
			setTimeout(function(){

				var $calendar = $('#inputCalendar').closest('.js_calendar');
				if (!$calendar.hasClass('calendar-open')) {
					$calendar.addClass('calendar-open');
					$('body').addClass('calendar-active');

				}
			}, 200);
		});

		$(document).on('click','#inputCalendar', function(e){
			var $calendar = $(this).closest('.js_calendar');
			var display = $('#ui-datepicker-div').css('display');
			if (display == 'block' && $calendar.hasClass('calendar-open')) {
				$.datepicker._hideDatepicker();

			} else {
				$('#inputCalendar').datepicker("show");
			}

		});


		$(document).on('click', '.js_calendar-control', function(){
			if ($(this).hasClass('is_active')) {
				var $this = $(this),
					$calendar = $(this).closest('.js_calendar'),
					$week = $calendar.find('.js_week'),
					weekValue = parseInt($week.html()),
					year = parseInt($week.attr('data-year')),
					next = true,
					newWeek = weekValue,
					newYear = year;

					if ($this.hasClass('calendar__prev')) {
						next = false;
					}
					if (next) {
						if (weekValue < 52) {
							newWeek = newWeek + 1;
						} else {
							newWeek = 1;
							newYear = newYear + 1;
						}
					} else {
						if (weekValue == 1) {
							newWeek = 52;
							newYear = newYear - 1;
						} else {
							newWeek = newWeek - 1;;

						}
					}

					if (newWeek === currentWeek) {
						$('.calendar__next').removeClass('is_active');
					} else {
						$('.calendar__next').addClass('is_active');
					}

					$week.html(newWeek);
					$week.attr('data-year', newYear);
					setCalendarWeek(newYear+'-'+newWeek, '-');
					$('#inputCalendar').attr('value', newYear+'-'+newWeek, '-');
					var $prevItem = $('#inputCalendar').prev();
					$prevItem.html(newWeek);
					updateMarktPriceHtml(newYear, newWeek);
			}
		});


		$(document).on('click', '.js_calendar-close', function(){
			$.datepicker._hideDatepicker();
		});

	}
	function getDateFromISOWeek(ywString, separator) {
	    try {
	        // console.log(ywString);
	        var ywArray = ywString.split(separator);
	        var y = ywArray[0];
	        var w = ywArray[1];
	        var simple = new Date(y, 0, 1 + (w - 1) * 7);
	        var dow = simple.getDay();
	        var ISOweekStart = simple;
	        if (dow <= 4)
	            ISOweekStart.setDate(simple.getDate() - simple.getDay() + 1);
	        else
	            ISOweekStart.setDate(simple.getDate() + 8 - simple.getDay());
	        return ISOweekStart;
	    } catch (err) {
	        console.error("Cannot convert Week into date");
	        return new Date();
	    }
	};
	function setCalendarWeek(ywString,separator) {
		$('#inputCalendar').datepicker("option","defaultDate",getDateFromISOWeek(ywString,separator));
		$('#inputCalendar').val(ywString);

	}
	function formatPrice(price) {
		if (price === '0.00') {
			return noDataString;
		} else {
			return price.replace('.',',') + ' €';
		}
	}
	function updateMarktPriceHtml(year,week) {

		year = parseInt(year);
		week = parseInt(week);

		// setTimeout(function(){
			var data = {
				action: 'load_price',
				request_year: year,
				request_week: week
			};

			$.ajax({
				dataType: 	'json',
				data: 		data,
				timeout:	10000,
				error:		function() {

					console.log('error');

				},
				success: 	function(response) {

					// console.log('success');

					$('.js_mastschweine, .js_zuchten, .js_ferkel').removeClass('o_typo--marktprice--empty');
					$('.js_mastschweine .currency, .js_zuchten .currency, .js_ferkel .currency').removeAttr('hidden');

					if (response.data.mastschweine === '0.00') {
						$('.js_mastschweine').addClass('o_typo--marktprice--empty');
						$('.js_mastschweine .currency').attr('hidden', true);
					}
					if (response.data.zuchten === '0.00') {
						$('.js_zuchten').addClass('o_typo--marktprice--empty');
						$('.js_zuchten .currency').attr('hidden', true);
					}
					if (response.data.ferkel === '0.00') {
						$('.js_ferkel').addClass('o_typo--marktprice--empty');
						$('.js_ferkel .currency').attr('hidden', true);
					}

					$('.js_mastschweine .value').text(formatPrice(response.data.mastschweine));
					$('.js_zuchten .value').text(formatPrice(response.data.zuchten));
					$('.js_ferkel .value').text(formatPrice(response.data.ferkel));



				}
			});
		// }, 100);
	}

});
define("root/Assets/Templates/Html/Calendar/Js/Calendar", function(){});

